import React, { useEffect, useState } from 'react';

import CommunityBigItem from './community-big-item/CommunityBigItem';
import {
  useSubscribeToCommunity,
  useUnsubscribeFromCommunity,
} from '../../../services/redux/api/communitiesApi';
import { useGetMyDetails } from '../../../services/redux/api/usersApi';
import CommunitySmallItem from './community-small-item/CommunitySmallItem';
import clsx from 'clsx';
import theme from '../../../styles/theme';
import { useStyles } from './CommunitiesList.styles';
import Search from '../search/Search';
import { ICommunity } from '../../../types/interfaces/community';

export const CommunityViewType = {
  big: 'big',
  small: 'small',
};

export default function CommunitiesList(props) {
  const {
    communities,
    type = CommunityViewType.big,
    showSearch = false,
  } = props;
  const { data: user } = useGetMyDetails();
  const [subscribeToCommunity] = useSubscribeToCommunity();
  const [unsubscribeFromCommunity] = useUnsubscribeFromCommunity();
  const { classes } = useStyles(theme);
  const [filterValue, setFilterValue] = useState<string>('');
  const [filteredCommunities, setFilteredCommunities] =
    useState<ICommunity[]>(communities);

  useEffect(() => {
    if (!filterValue) {
      setFilteredCommunities(communities);
    } else {
      setFilteredCommunities(
        communities.filter(
          (u) =>
            u.firstname?.toLowerCase().indexOf(filterValue.toLowerCase()) !==
              -1 ||
            u.lastname?.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1,
        ),
      );
    }
  }, [filterValue, communities]);

  function subscribeHandler(communityId) {
    subscribeToCommunity({ id: communityId }).catch((e) => console.log(e));
  }

  function unsubscribeHandler(communityId) {
    unsubscribeFromCommunity({ id: communityId }).catch((e) => console.log(e));
  }

  return (
    <div
      className={clsx(
        classes.communitiesListWrapper,
        type === CommunityViewType.small && classes.narrowScreen,
      )}>
      {showSearch && (
        <Search
          fullWidth
          value={filterValue}
          onChange={setFilterValue}
          className={classes.communitiesListSearch}
        />
      )}
      {filteredCommunities?.map((c) => (
        <React.Fragment key={c.id}>
          {type === CommunityViewType.big ? (
            <CommunityBigItem
              community={c}
              subscriptionRelation={user?.subscriptions?.find(
                (s) => s.toCommunityId === c.id,
              )}
              onSubscribe={subscribeHandler}
              onUnsubscribe={unsubscribeHandler}
            />
          ) : (
            <CommunitySmallItem community={c} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
